"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lsosIconUrl = exports.getLsosProjectInfo = void 0;
var emojiRegex_1 = require("../utils/emojiRegex");
var assertUsage_1 = require("../donation-reminder/utils/assertUsage");
exports.lsosIconUrl = "https://lsos.org/logo.svg";
function getLsosProjectInfo(_a) {
    var projectName = _a.projectName, npmName = _a.npmName, donationText = _a.donationText;
    var iconUrl = "https://lsos.org/npm/" + npmName + "/logo.png";
    var donatePageUrl = "https://lsos.org/d/" + npmName;
    var donationTextWithEmojis = donationText;
    var donationTextWithoutEmojis = removeEmojis(donationText);
    checkIfLsosProjectExists(npmName, iconUrl);
    return {
        projectName: projectName,
        iconUrl: iconUrl,
        donatePageUrl: donatePageUrl,
        donationTextWithoutEmojis: donationTextWithoutEmojis,
        donationTextWithEmojis: donationTextWithEmojis,
    };
}
exports.getLsosProjectInfo = getLsosProjectInfo;
function removeEmojis(str) {
    // Remove emoji codes
    var processed = str;
    processed = processed.split(new RegExp(emojiRegex_1.emojiRegex)).join(" ");
    // Remove white-space doublets
    processed = processed.split(/\s/g).filter(Boolean).join(" ");
    // Remove erronous white-spaces
    processed = processed
        .split(/\s(?![a-z])/gi)
        .filter(Boolean)
        .join("");
    processed = processed.split(/^\s/).filter(Boolean).join("");
    // Add trailing dot
    if (/[^a-z]/i.test(processed)) {
        processed = processed + ".";
    }
    return processed;
}
function checkIfLsosProjectExists(npmName, iconUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var projectIconExists, isOnline;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, imageExists(iconUrl)];
                case 1:
                    projectIconExists = _a.sent();
                    if (projectIconExists === true) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, imageExists(exports.lsosIconUrl)];
                case 2:
                    isOnline = _a.sent();
                    if (isOnline === false) {
                        // No-op: browser is offline
                        return [2 /*return*/];
                    }
                    if (isOnline === null || projectIconExists === null) {
                        return [2 /*return*/];
                    }
                    console.assert(isOnline === true && projectIconExists === false);
                    assertUsage_1.assertWarning(false, "The project `" + npmName + "` is unknown to the Lsos. Contact your Lsos manager, or go to https://lsos.org/join if you don't have one yet.");
                    return [2 /*return*/];
            }
        });
    });
}
function imageExists(imageUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var imgEl, resolve, promise, TIMEOUT;
        return __generator(this, function (_a) {
            imgEl = document.createElement("img");
            promise = new Promise(function (r) {
                resolve = r;
            });
            imgEl.onload = function () {
                resolve(true);
            };
            imgEl.onerror = function () {
                resolve(false);
            };
            TIMEOUT = 5 * 1000;
            setTimeout(function () {
                resolve(null);
            }, TIMEOUT);
            imgEl.src = imageUrl;
            return [2 /*return*/, promise];
        });
    });
}
//# sourceMappingURL=getLsosProjectInfo.js.map